(() => {
  if (typeof window.FaraCrate?.prepare === 'function' || typeof window.FaraCrateStore !== 'function') return;
  const dialog = document.getElementById('FaraCrate');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  let labels = {};
  try { labels = JSON.parse(document.getElementById('FaraCrateLabels').textContent); } catch { return; }
  let storage;
  try { storage = window.localStorage; } catch { storage = null; }
  const store = window.FaraCrateStore(storage, location.origin);
  const records = dialog.querySelector('[id=FaraCrateRecords]');
  const status = dialog.querySelector('[data-crate-status]');
  const pageStatus = document.getElementById('FaraCrateStatus');
  const more = dialog.querySelector('[data-crate-more]');
  const clear = dialog.querySelector('[data-crate-clear]');
  const playControl = dialog.querySelector('[data-crate-play]');
  const shareControl = dialog.querySelector('[data-crate-share]');
  const selectionActions = dialog.querySelector('[data-crate-selection-actions]');
  const selectionNote = dialog.querySelector('[data-crate-selection-note]');
  const sharePanel = dialog.querySelector('[data-crate-share-panel]');
  const shareInput = dialog.querySelector('[data-crate-share-url]');
  const sharedTab = dialog.querySelector('[data-crate-tab="shared"]');
  const sharing = window.FaraCrateStore.share;
  const products = new Map();
  let activeTab = 'saved', visible = 12, renderId = 0, opener, controller;
  let sharedItems = [], lastSharedHash = '', actionRevision = 0, actionController, playPending = false;
  let radioState = window.FaraRadio?.getState?.() || null;
  let pendingDefinition = null, commandIssued = false, actionRadioSignature = '';
  const queues = new Map();
  const phrase = (key, title = '') => (labels[key] || '').replace('__title__', title);
  const rootUrl = new URL(dialog.dataset.rootUrl || '/', location.origin);
  const productUrl = handle => new URL('products/' + encodeURIComponent(handle), rootUrl).href;
  const entryFor = button => ({handle: button.dataset.faraSave, title: button.dataset.saveTitle, artist: button.dataset.saveArtist, image: button.dataset.saveImage, preview: button.dataset.savePreview});
  function announce(message) { status.textContent = message; pageStatus.textContent = message; }
  const selectedItems = () => activeTab === 'shared' ? sharedItems : store.snapshot()[activeTab] || [];
  const selectionKey = () => activeTab + ':' + sharing.handles(selectedItems(), 60).join(',');
  const radioSignature = state => JSON.stringify([state?.issue?.id, state?.issue?.handles, state?.track?.handle, state?.playing, state?.intended]);
  function syncActions() {
    if (!playControl || !shareControl) return;
    const items = selectedItems(), definition = queues.get(selectionKey());
    const exact = sharing.matches(radioState, definition), playing = exact && radioState.playing;
    selectionActions.hidden = activeTab === 'heard' || !items.length;
    playControl.disabled = playPending || !items.length || typeof window.FaraRadio?.startIssue !== 'function';
    playControl.setAttribute('aria-busy', String(playPending));
    playControl.setAttribute('aria-pressed', String(Boolean(playing)));
    playControl.textContent = playPending ? labels.preparing : playing ? labels.pause_selection : exact ? labels.resume_selection : labels[activeTab === 'shared' ? 'play_shared' : 'play_crate'];
    shareControl.disabled = !items.length;
    selectionNote.textContent = items.length > sharing.limit ? labels.selection_limit : labels.selection_note;
  }
  function cancelAction() {
    actionRevision++;
    actionController?.abort();
    if (playPending && commandIssued && sharing.matches(radioState, pendingDefinition) && radioState.intended && !radioState.playing) window.FaraRadio?.pause();
    playPending = false;
    pendingDefinition = null; commandIssued = false;
    syncActions();
  }
  async function productFor(handle, signal) {
    if (products.has(handle)) return products.get(handle);
    try {
      const response = await fetch(productUrl(handle) + '.js', {credentials:'same-origin', headers:{Accept:'application/json'}, signal});
      if (!response.ok) return null;
      const product = await response.json();
      if (product?.handle !== handle || !Array.isArray(product.variants)) return null;
      products.set(handle, product); return product;
    } catch { return null; }
  }
  async function awaitPlayback(action) {
    let timer;
    try {
      return await Promise.race([Promise.resolve().then(action), new Promise((_, reject) => { timer = setTimeout(() => reject(new Error('Playback timed out')), 10000); })]);
    } finally { clearTimeout(timer); }
  }
  async function playSelection() {
    if (playPending || !window.FaraRadio?.startIssue) return;
    const key = selectionKey(), existing = queues.get(key), radio = window.FaraRadio;
    radioState = radio.getState?.() || radioState;
    if (sharing.matches(radioState, existing) && radioState.playing) {
      radio.pause(); return;
    }
    const revision = ++actionRevision;
    actionController?.abort(); actionController = new AbortController();
    const signal = actionController.signal;
    actionRadioSignature = radioSignature(radioState); pendingDefinition = null; commandIssued = false;
    playPending = true; syncActions();
    let timeout;
    try {
      if (sharing.matches(radioState, existing)) {
        pendingDefinition = existing; commandIssued = true;
        await awaitPlayback(() => revision === actionRevision && dialog.open ? radio.resume() : false);
        if (revision === actionRevision && sharing.matches(radioState, existing) && !radioState.playing) announce(labels.play_error);
        return;
      }
      let catalogue;
      try { catalogue = JSON.parse(document.getElementById('FaraRadioPlaylist')?.textContent || '{}'); } catch { catalogue = {}; }
      const radioHandles = sharing.handles((catalogue.tracks || []).map(track => track?.[3]), 500);
      const known = new Set(radioHandles);
      const candidates = sharing.handles(selectedItems(), 60).filter(handle => known.has(handle));
      let cursor = 0;
      const currentController = actionController;
      timeout = setTimeout(() => currentController.abort(), 10000);
      async function worker() { while (cursor < candidates.length && !signal.aborted) await productFor(candidates[cursor++], signal); }
      await Promise.all(Array.from({length:Math.min(4, candidates.length)}, worker));
      clearTimeout(timeout);
      if (revision !== actionRevision || !dialog.open || key !== selectionKey()) return;
      if (signal.aborted) { announce(labels.play_error); return; }
      const handles = sharing.playable(candidates, radioHandles, products);
      if (!handles.length) { announce(labels.no_playable); return; }
      const definition = {id:sharing.queueId(handles), title:labels[activeTab === 'shared' ? 'shared_title' : 'queue_title'], handles, completeMessage:labels.queue_complete};
      queues.set(key, definition);
      pendingDefinition = definition; commandIssued = true;
      const played = await awaitPlayback(() => revision === actionRevision && dialog.open ? radio.startIssue(definition) : false);
      if (revision !== actionRevision || !dialog.open) return;
      if (played === false || !sharing.matches(radioState, definition) || !radioState.playing) announce(labels.play_error);
      else announce(labels.queue_started.replace('__count__', handles.length));
    } catch {
      if (revision === actionRevision && dialog.open) {
        if (sharing.matches(radioState, pendingDefinition) && radioState.intended && !radioState.playing) radio.pause();
        announce(labels.play_error);
      }
    } finally {
      clearTimeout(timeout);
      if (revision === actionRevision) { playPending = false; pendingDefinition = null; commandIssued = false; syncActions(); }
    }
  }
  async function shareSelection() {
    const url = sharing.url(rootUrl.href, selectedItems());
    if (!url || !shareInput) return;
    const revision = actionRevision, key = selectionKey();
    shareInput.value = url; sharePanel.hidden = false;
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(url);
      if (revision === actionRevision && dialog.open && key === selectionKey()) announce(labels.share_copied);
    } catch {
      if (revision !== actionRevision || !dialog.open || key !== selectionKey()) return;
      announce(labels.share_fallback); shareInput.focus(); shareInput.select();
    }
  }
  function sync() {
    const state = store.snapshot(), handles = new Set(state.saved.map(item => item.handle));
    document.querySelectorAll('[data-fara-save]').forEach(button => {
      const selected = handles.has(button.dataset.faraSave);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(selected));
      const label = phrase(selected ? 'remove_title' : 'save_title', button.dataset.saveTitle || '');
      button.setAttribute('aria-label', label); button.title = label;
      const text = button.querySelector('[data-save-label]');
      if (text) text.textContent = labels[selected ? 'saved' : 'save'];
    });
    document.querySelectorAll('[data-fara-crate-open]').forEach(button => {button.hidden = false;});
    document.querySelectorAll('[data-crate-count]').forEach(node => {node.textContent = state.saved.length ? String(state.saved.length) : '';});
    dialog.querySelector('[data-crate-saved-count]').textContent = state.saved.length;
    dialog.querySelector('[data-crate-storage]').textContent = labels[state.persistent ? 'device_note' : 'visit_note'];
    syncActions();
  }
  const node = (tag, className, text) => {
    const element = document.createElement(tag); if (className) element.className = className;
    if (text != null) element.textContent = text; return element;
  };
  function saveButton(item) {
    const button = node('button', 'fara-save-button'); button.type = 'button';
    button.dataset.faraSave = item.handle; button.dataset.saveTitle = item.title; button.dataset.saveArtist = item.artist; button.dataset.saveImage = item.image;
    button.dataset.savePreview = item.preview;
    button.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 3h12v18l-6-4-6 4z"/></svg><span data-save-label></span>';
    return button;
  }
  function makeRow(item) {
    const row = node('article', 'fara-crate-row'); row.dataset.crateHandle = item.handle;
    const art = node('div', 'fara-crate-row__art');
    const imageLink = node('a'); imageLink.href = productUrl(item.handle); imageLink.setAttribute('aria-label', item.title);
    if (item.image) {
      const image = node('img'); image.src = item.image; image.alt = ''; image.width = 88; image.height = 88; image.loading = 'lazy'; image.decoding = 'async'; imageLink.append(image);
    }
    art.append(imageLink); row.append(art);
    const copy = node('div', 'fara-crate-row__copy');
    copy.append(node('p', 'fara-crate-row__artist', item.artist));
    const heading = node('h3'), link = node('a', '', item.title); link.href = productUrl(item.handle); heading.append(link); copy.append(heading);
    const actions = node('div', 'fara-crate-row__actions'), price = node('a', 'fara-crate-row__price', labels.view_record); price.href = link.href;
    const save = saveButton(item);
    if (activeTab === 'shared') { save.disabled = true; price.textContent = labels.checking_record; }
    actions.append(price, save); copy.append(actions); row.append(copy);
    return row;
  }
  function enrich(row, entry, product) {
    if (!product || product.handle !== entry.handle || !Array.isArray(product.variants) || !product.variants.length) {
      if (activeTab === 'shared') {
        row.querySelector('.fara-crate-row__price').textContent = labels.record_missing;
        row.querySelector('[data-fara-save]').disabled = true;
      }
      return;
    }
    const title = typeof product.title === 'string' ? product.title : entry.title;
    const image = store.clean({...entry, image: product.featured_image})?.image;
    const art = row.querySelector('.fara-crate-row__art'), imageLink = art.querySelector('a');
    row.querySelector('h3 a').textContent = title; imageLink.setAttribute('aria-label', title);
    const save = row.querySelector('[data-fara-save]'); save.dataset.saveTitle = title; save.disabled = false;
    if (activeTab === 'shared') {
      const artist = typeof product.vendor === 'string' ? product.vendor : '';
      save.dataset.saveArtist = artist; row.querySelector('.fara-crate-row__artist').textContent = artist;
      Object.assign(entry, {title, artist, image: image || ''});
    }
    if (image) {
      const url = new URL(image); url.searchParams.set('width', '240');
      save.dataset.saveImage = url.href;
      if (!imageLink.querySelector('img')) {const img = node('img'); img.alt = ''; img.width = 88; img.height = 88; img.loading = 'lazy'; img.decoding = 'async'; imageLink.append(img);}
      imageLink.querySelector('img').src = url.href;
    }
    const available = product.variants.some(variant => variant.available);
    const price = row.querySelector('.fara-crate-row__price');
    if (!available) price.textContent = labels.unavailable;
    else if (Number.isFinite(product.price) && product.price >= 0) {
      try {price.textContent = (product.price_varies ? labels.from + ' ' : '') + new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: dialog.dataset.currency}).format(product.price / 100);} catch {}
    }
    if (!available) return;
    const preview = node('button', 'fara-image-preview'); preview.type = 'button'; preview.dataset.faraPreview = ''; preview.dataset.previewProducts = JSON.stringify([entry.handle]); preview.dataset.previewName = title; preview.dataset.playLabel = labels.preview; preview.dataset.pauseLabel = labels.pause;
    if (entry.preview) preview.dataset.previewTracks = JSON.stringify([{url:entry.preview, title}]);
    preview.setAttribute('aria-label', phrase('preview_title', title)); preview.setAttribute('aria-pressed', 'false'); preview.hidden = true;
    preview.innerHTML = '<span data-preview-icon aria-hidden="true">▶</span><span class="visually-hidden" data-preview-label></span>';
    preview.querySelector('[data-preview-label]').textContent = labels.preview; art.append(preview);
    const cartRoot = node('div', 'fara-cart-control'); cartRoot.dataset.faraCartControl = '';
    const cart = node('a', 'fara-cart-button'); cart.href = productUrl(entry.handle);
    cart.setAttribute('aria-label', phrase(product.variants.length === 1 ? 'add_title' : 'choose_title', title));
    if (product.variants.length === 1) {cart.dataset.faraCartProductUrl = cart.href; cart.dataset.cartTitle = title; cart.dataset.noRouter = '';}
    cart.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 3h2l2.4 12h10.9l2-8H6"/><circle cx="9" cy="20" r="1"/><circle cx="17" cy="20" r="1"/></svg>';
    cartRoot.append(cart); art.append(cartRoot);
  }
  async function loadRows(items, id, signal) {
    let cursor = 0;
    async function worker() {
      while (cursor < items.length && !signal.aborted) {
        const item = items[cursor++], product = await productFor(item.handle, signal);
        if (id !== renderId || signal.aborted || !dialog.open) return;
        const row = records.querySelector('[data-crate-handle="' + item.handle + '"]');
        if (row) enrich(row, item, product);
      }
    }
    await Promise.all(Array.from({length: Math.min(4, items.length)}, worker));
    if (id === renderId && !signal.aborted && dialog.open) {sync(); document.dispatchEvent(new CustomEvent('fara:preview-prepare'));}
  }
  function render() {
    cancelAction();
    if (sharePanel) sharePanel.hidden = true;
    controller?.abort(); controller = new AbortController();
    const id = ++renderId, items = selectedItems(), shown = items.slice(0, visible);
    dialog.querySelectorAll('[data-crate-tab]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.crateTab === activeTab)));
    clear.hidden = activeTab !== 'heard' || !items.length;
    dialog.querySelector('[data-crate-summary]').textContent = activeTab === 'heard' ? labels.radio_history : labels[activeTab === 'shared' ? 'shared_summary' : 'saved_summary'];
    records.replaceChildren(...shown.map(makeRow));
    if (!items.length) {
      const empty = node('div', 'fara-crate__empty'); empty.append(node('h3','',labels[activeTab === 'saved' ? 'empty_saved_title' : 'empty_heard_title']),node('p','',labels[activeTab === 'saved' ? 'empty_saved_copy' : 'empty_heard_copy'])); records.append(empty);
    }
    more.hidden = visible >= items.length;
    sync(); document.dispatchEvent(new CustomEvent('fara:preview-prepare'));
    if (shown.length) loadRows(shown, id, controller.signal);
  }
  function close() { if (dialog.open) dialog.close(); }
  function open(button) { opener = button || document.activeElement; visible = 12; status.textContent = ''; products.clear(); dialog.showModal(); render(); }
  function acceptShared() {
    if (document.getElementById('MainContent')?.getAttribute('aria-busy') === 'true') return;
    const hash = location.hash;
    if (!sharing || hash === lastSharedHash) return;
    const handles = sharing.parseHash(hash);
    if (!handles) return;
    lastSharedHash = hash;
    sharedItems = handles.map(handle => ({handle, title:handle, artist:'', image:'', preview:''}));
    if (sharedTab) sharedTab.hidden = false;
    activeTab = 'shared';
    if (dialog.open) render();
    else open(document.querySelector('[data-fara-crate-open]'));
    announce(labels.shared_notice);
  }
  function prepare() {
    sync();
    if (typeof location.hash === 'string' && !location.hash.startsWith('#crate=')) lastSharedHash = '';
    // Shopify's soft navigation finishes moving focus after section:load.
    // Defer the shared-link dialog until that work has completed.
    if (typeof location.hash === 'string' && location.hash.startsWith('#crate=') && location.hash !== lastSharedHash) setTimeout(acceptShared, 0);
  }
  document.addEventListener('click', event => {
    const openButton = event.target.closest?.('[data-fara-crate-open]');
    if (openButton) {event.preventDefault(); if (!dialog.open) open(openButton); return;}
    const button = event.target.closest?.('[data-fara-save]');
    if (!button || button.disabled) return;
    event.preventDefault();
    cancelAction();
    const entry = entryFor(button), result = store.toggle(entry);
    announce(result === 'full' ? labels.full : phrase(result === 'saved' ? 'saved_message' : 'removed_message', entry.title));
    if (dialog.open && activeTab === 'saved') {
      const inside = dialog.contains(button), index = [...records.children].indexOf(button.closest('.fara-crate-row'));
      render();
      if (inside) (records.children[Math.min(Math.max(index, 0), records.children.length - 1)]?.querySelector('[data-fara-save]') || dialog.querySelector('[data-crate-tab="saved"]')).focus({preventScroll:true});
    } else sync();
  });
  dialog.addEventListener('click', event => {
    if (event.target.closest('[data-crate-close]')) {close(); return;}
    if (event.target.closest('[data-crate-play]')) {playSelection(); return;}
    if (event.target.closest('[data-crate-share]')) {shareSelection(); return;}
    const tab = event.target.closest('[data-crate-tab]');
    if (tab && tab.dataset.crateTab !== activeTab) {activeTab = tab.dataset.crateTab; visible = 12; status.textContent = ''; render();}
    if (event.target.closest('[data-crate-more]')) {const previous = visible; visible += 12; render(); records.children[previous]?.querySelector('h3 a')?.focus({preventScroll:true});}
    if (event.target.closest('[data-crate-clear]')) {store.clearHistory(); render(); announce(labels.cleared); dialog.querySelector('[data-crate-tab="heard"]').focus();}
    if (event.target === dialog) {const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();}
    if (event.target.closest('a[href]') && !event.target.closest('[data-fara-cart-product-url]')) close();
  });
  dialog.addEventListener('close', () => {
    cancelAction();
    controller?.abort(); renderId++; records.replaceChildren();
    const notice = dialog.querySelector('.fara-cart-notice'); if (notice) notice.hidden = true;
    document.dispatchEvent(new CustomEvent('fara:preview-prepare'));
    if (opener?.isConnected) opener.focus({preventScroll:true});
  });
  window.addEventListener('fara:record-heard', event => {
    if (event.detail?.source !== 'radio' || !store.heard(event.detail)) return;
    if (dialog.open && activeTab === 'heard' && !records.contains(document.activeElement)) render(); else sync();
  });
  window.addEventListener('storage', event => {
    if (event.key !== store.key && event.key !== null) return;
    store.reload(event.key === null ? null : event.newValue);
    cancelAction();
    if (dialog.open && !records.contains(document.activeElement)) render(); else sync();
  });
  window.addEventListener('fara:before-navigate', close);
  window.addEventListener('fara:radio-state', event => {
    radioState = event.detail;
    if (playPending && (commandIssued ? !sharing.matches(radioState, pendingDefinition) : radioSignature(radioState) !== actionRadioSignature)) cancelAction();
    syncActions();
  });
  window.addEventListener('hashchange', prepare);
  window.addEventListener('popstate', prepare);
  document.addEventListener('shopify:section:load', prepare);
  document.addEventListener('fara:preview-prepare', sync);
  window.FaraCrate = {prepare};
  prepare();
})();
